import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {Countries} from '../../models/countries.model';
import {CountriesService} from '../../services/countries.service';
import {map, startWith} from 'rxjs/operators';
/*
* <mat-option value='5d6ac4e5564f432d70e45605'> Australia</mat-option>
            <mat-option value='5d6ac4e5564f432d70e45605'> Australia</mat-option>
            <mat-option value='5d6ac4e5564f432d70e45636'> Denmark</mat-option>
            <mat-option value='5d6ac4e5564f432d70e45607'> Germany</mat-option>
            <mat-option value='5d6ac4e5564f432d70e4561a'>Sweden</mat-option>
            <mat-option value='5d6ac4e5564f432d70e456b8'>United Kingdom</mat-option>
            <mat-option value='5d6ac4e5564f432d70e455f9'>United States</mat-option>
* */
const moreCountries: any = [
  {
    _id: '5e0e741a22f7303a38447adb',
    name: 'AUSTRALIA'
  },
  {
    _id: '5e0e741a22f7303a38447b00',
    name: 'DENMARK'
  },
  {
    _id: '5e0e741a22f7303a38447afe',
    name: 'GERMANY'
  },
  {
    _id: '5e0e741a22f7303a38447b6d',
    name: 'SWEDEN'
  },
  {
    _id: '5e0e741a22f7303a38447b11',
    name: 'UNITED KINGDOM'
  },
  {
    _id: '5e0e741a22f7303a38447b86',
    name: 'UNITED STATES'
  }
];

@Component({
  selector: 'app-nationalities-autocomplete',
  templateUrl: './nationalities-autocomplete.component.html',
  styleUrls: ['./nationalities-autocomplete.component.scss']
})
export class NationalitiesAutocompleteComponent implements OnInit {
  @Input() countryControl: FormControl = new FormControl();

  countries: Countries[] = [];

  @Input() placeholder: string;

  filteredCountries: Observable<any>;

  @Output() selectCountry: EventEmitter<Countries> = new EventEmitter<Countries>();

  @Input() country: string;

  constructor(private countriesService: CountriesService) {

  }

  ngOnInit() {
    this.getCountries();
    this.filteredCountries = this.countryControl.valueChanges
      .pipe(
        startWith(''),
        map(state => state ? this._filterStates(state) : this.countries.slice())
      );
  }

  private _filterStates(value: Countries | null): Countries[] {
    const filterValue = typeof value === 'string' ? (value as any).toLowerCase() : value ? value.name.toLowerCase() : null;

    return this.countries.filter(state => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  private async getCountries(): Promise<void> {
    const countries = await this.countriesService.getCitizenships().toPromise();
    this.countries = [...moreCountries, ...countries];
    if (this.country) {
      this.countryControl.setValue(this.countries.find(c => c._id === this.country));
    }
  }

  displayFn(country) {
    return country ? country.name : '';
  }

}
